export default "__VITE_ASSET__PZj7vxdd__"